//import React from 'react';
import React, { useEffect, Fragment } from 'react';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { H5, H6, TextInput, DatePicker, Checkbox } from '../../../components/index.js';
import { renderRadiobutton } from '../../../components/ncss/Radiobutton.js';
import materialLeftFields from '../../../constants/json/radiobuttons/materialLeftFields.json';
import rootCauseFields from '../../../constants/json/radiobuttons/rootCauseFields.json';
import futureProductFields from '../../../constants/json/radiobuttons/futureProductFields.json';
import currectiveActionFields from '../../../constants/json/radiobuttons/currectiveActionFields.json';
import UploadAttachment from '../../../components/uploadAttachment/UploadAttachment.js';
import { createServiceAction } from '../../../util/actionHelper.js';
import { updateGuideNo, updateGuideYes, updateFutureProductYes, updateDisgardTrf, clearFormValueQRF } from '../../../actions/qrfActions.js';
import { history } from '../../../util/index.js';
import remediationConstants from './Remediation.constants.js';

const { maxTextLength } = remediationConstants;

const Remediation = ({ displaySubmitButtonQrf, displayClearButtonQrf, clearFormValueQRF, attachmentQrf, attachment, remediation, trfDetail, submitFrf, submitQrf, initialize, updateQrf }) => {
  const dispatch = useDispatch();
  const disgardTrf = useSelector(state => state.qrf.disgardTrf);

  useEffect(() => {
    displaySubmitButtonQrf(false);
    displayClearButtonQrf(true);
  }, [displaySubmitButtonQrf, displayClearButtonQrf]);

  /**
   * Handles the change event for the effected material input.
   *
   * @param {string} value - The value of the selected radio button.
   */
  const handleEffectedMaterial = (value) => {
    dispatch(updateGuideYes(false))
    dispatch(updateGuideNo(false))
  }
  const handleFutureProduct = () => {
    dispatch(updateDisgardTrf(false));
    dispatch(updateFutureProductYes(false));
  }

  const handleRootCause = (value) => {
    if (value === "No") {
      if (remediation.frfId === null) {
        dispatch(change('Remediation', 'failureDesc', ''));
        dispatch(change('Remediation', 'dateOfCompletion', null));
        dispatch(change('Remediation', 'correctiveAction', ''));
        dispatch(change('Remediation', 'rootCause', ''));
        dispatch(change('Remediation', 'isUploaded', ''));
        dispatch(change('Remediation', 'proposedCorrectiveAction', ''));
      }
      handlePartialSave(value);
    }
  }

  const handleCheckBox = (name, checked) => {
    if (name === "guide-yes") {
      dispatch(updateGuideYes(checked))
      handleRadioButtonChange(checked)
    } else if (name === "guide-no") {
      dispatch(updateGuideNo(checked));
      handleRadioButtonChange(checked)
    } else if (name === "futureProductYes") {
      dispatch(updateFutureProductYes(checked));
      if (!checked && remediation.frfId === null) {
        clearFRFForm();
      }
    }
  };
  const clearFRFForm = () => {
    dispatch(change('Remediation', 'PDCA', ''));
    dispatch(change('Remediation', 'failureDesc', ''));
    dispatch(change('Remediation', 'dateOfCompletion', null));
    dispatch(change('Remediation', 'correctiveAction', ''));
    dispatch(change('Remediation', 'rootCause', ''));
    dispatch(change('Remediation', 'isUploaded', false));
    dispatch(change('Remediation', 'proposedCorrectiveAction', ''));
  }
  const handleRadioButtonChange = (checked) => {
    if (!checked) {
      clearFormValueQRF();
    }
  }

  const handlePartialSave = (PDCA) => {
    const requestObject = {};
    requestObject.trfId = trfDetail.data.trfDetails.trfId;
    requestObject.quantity = remediation.materialAffectedQty;
    requestObject.materialWorth = remediation.materialWorth;
    requestObject.leftFacility = remediation.affectedMaterialLeft;
    requestObject.futureProduction = remediation.futureProduction;
    requestObject.PDCA = PDCA;
    if (trfDetail.data.qrfDetails && trfDetail.data.qrfDetails.qrfId) {
      requestObject.qrfId = trfDetail.data.qrfDetails.qrfId;
      updateQrf(requestObject, history);
    } else {
      submitQrf(requestObject, history)
    }

  }

  const handleDiscardTrf = (checked) => {
    dispatch(updateDisgardTrf(checked));
    if (!checked) {
      clearFRFForm();
    }
  }
  return (

    <form className="form" data-testid="qrf-info">
      <div>
        <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
          <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
            <H5 className="ncss-col-sm-5  u-bold trf-data-text">
              Has any of the affected material left the manufacturer’s facility?
              <span className='astericks ml-neg3'>&#42;</span>
            </H5>
            <div className="ncss-col-sm-8 ncss-radio-container">
              {materialLeftFields.map(data => (
                <div key={data.id} className="ncss-col-sm-2 description ncss-radio-container">
                  <Field
                    type="radio"
                    component={renderRadiobutton}
                    name="affectedMaterialLeft"
                    value={data.value}
                    label={data.label}
                    id={data.id}
                    isIcon={false}
                    onChange={e => handleEffectedMaterial(data.value)}
                    disabled={remediation.guideYes || remediation.guideNo}
                  />
                </div>
              ))}
            </div>
          </div>


          {(remediation.affectedMaterialLeft === 'Yes' || remediation.guideYes) &&
            (<Fragment><div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
              <div className="ncss-col-sm-5  u-bold trf-data-text">
              </div>
              <div className="ncss-col-sm-8 pad-top">
                <span className="ncss-checkbox-container">
                  <Field
                    type="checkbox"
                    component={Checkbox}
                    name="guideYes"

                    label="I agree and understand the necessity to quarantine the affected material in our possession, as well as immediately inform any receiver of the action to quarantine material as well"
                    onChange={(e) => handleCheckBox('guide-yes', e)}
                    defaultSelectedValue={remediation.guideYes}
                    disabled={!!remediation.qrfId}
                  />
                </span>
              </div>
            </div>
            </Fragment>
            )}
          {(remediation.affectedMaterialLeft === 'No' || remediation.guideNo) && (

            <Fragment><div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
              <div className="ncss-col-sm-5  u-bold trf-data-text">
              </div>
              <div className="ncss-col-sm-8 pad-top">
                <span className="ncss-checkbox-container">
                  <Field
                    type="checkbox"
                    component={Checkbox}
                    name="guideNo"
                    label="I agree and understand the necessity to quarantine the affected material in our possession"
                    defaultSelectedValue={remediation.guideNo}
                    onChange={(e) => handleCheckBox('guide-no', e)}
                    disabled={!!remediation.qrfId}
                  />
                </span>
              </div>
            </div>
            </Fragment>
          )}
          {(remediation.guideYes || remediation.guideNo) && (
            <Fragment>
              <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  How much material is affected by this failure? <span className='astericks ml-neg3'>&#42;</span>

                </div>
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  <Field component={TextInput} name="materialAffectedQty" type="text" maxLength={maxTextLength} />
                </div>
              </div>
              <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  How much is the material worth? <span className='astericks ml-neg3'>&#42;</span>
                  <H6 className="ncss-col-sm-6 u-bold p1-top-sm p1-bottom-sm">
                    <span className="normal-text"> (To go after How much material is affected by this failure?)</span>
                  </H6>
                </div>
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  <Field component={TextInput} name="materialWorth" type="text" maxLength={maxTextLength} />
                </div>
              </div>

              <div className="ncss-col-sm-12 inline-flex-display p5-sm u-bold qrf-padding-zero ie-inline-display">
                <H5 className="ncss-col-sm-5  u-bold trf-data-text">
                  Do you intend to use this material for future product? <span className='astericks ml-neg3'>&#42;</span>
                </H5>
                <div className="ncss-col-sm-8 ncss-radio-container">
                  {futureProductFields.map(data => (
                    <div key={data.id} className="ncss-col-sm-2 description ncss-radio-container">
                      <Field
                        type="radio"
                        component={renderRadiobutton}
                        name="futureProduction"
                        value={data.value}
                        label={data.label}
                        id={data.id}
                        isIcon={false}
                        onChange={e => handleFutureProduct(data.value)}
                        disabled={remediation.disgardTrf || remediation.futureProductYes}
                      />
                    </div>
                  ))}

                </div>
              </div>
            </Fragment>)}

          {(remediation.futureProduction === 'No' && (remediation.guideNo || remediation.guideYes)) ? (
            <Fragment>
              <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
                <div className="ncss-col-sm-5  u-bold trf-data-text">
                </div>
                <div className="ncss-col-sm-8 pad-top">
                  <p className='pl2-sm title-text'>
                    Discard or discontinue this material for any future Nike production.
                  </p>
                </div>
              </div>
              <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
                <div className="ncss-col-sm-5  u-bold trf-data-text">
                </div>
                <div className="ncss-col-sm-8 pad-top">
                  <span className="ncss-checkbox-container">
                    <Field type="checkbox"
                      component={Checkbox}
                      label="Please confirm your decision to discard or discontinue this material"
                      name="disgardTrf"
                      defaultSelectedValue={disgardTrf}
                      onChange={(e) => handleDiscardTrf(e)}
                    />
                  </span>
                </div>
              </div>
            </Fragment>
          ) : ''}
          {(remediation.futureProduction === 'Yes' && (remediation.guideNo || remediation.guideYes)) ?
            (
              <Fragment>
                <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
                  <div className="ncss-col-sm-5  u-bold trf-data-text">
                  </div>
                  <div className="ncss-col-sm-8 pad-top">
                    <p className='pl2-sm title-text'>
                      Complete Root Cause Analysis. Nike requires all materials to pass according to the Chemistry Playbook RSL policy.
                    </p>
                  </div>
                </div>
                <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
                  <div className="ncss-col-sm-5  u-bold trf-data-text">
                  </div>
                  <div className="ncss-col-sm-8 pad-top">

                    <span className="ncss-checkbox-container">
                      <Field type="checkbox"
                        component={Checkbox}
                        label="I understand and agree"
                        name="futureProductYes"
                        defaultSelectedValue={remediation.futureProductYes}
                        onChange={(e) => handleCheckBox("futureProductYes", e)}
                      />
                    </span>
                  </div>
                </div>
              </Fragment>
            ) : null}
          {(remediation.futureProductYes && remediation.futureProduction === 'Yes' && (remediation.guideNo || remediation.guideYes)) ? (
            <Fragment>
              <div className="ncss-col-sm-12 inline-flex-display p5-sm u-bold qrf-padding-zero ie-inline-display">
                <H5 className="ncss-col-sm-5  u-bold trf-data-text">
                  Have you completed the Root Cause Analysis? <span className='astericks ml-neg3'>&#42;</span>
                </H5>
                <div className="ncss-col-sm-8 ncss-radio-container">
                  {rootCauseFields.map(data => (
                    <div key={data.id} className="ncss-col-sm-2 description ncss-radio-container">
                      <Field
                        type="radio"
                        component={renderRadiobutton}
                        name="PDCA"
                        value={data.value}
                        label={data.label}
                        id={data.id}
                        isIcon={false}
                        onChange={e => handleRootCause(data.value)}
                      // disabled={remediation.guideYes || remediation.guideNo}
                      />
                    </div>
                  ))}

                </div>
              </div>

            </Fragment>) : ''}
          {remediation.PDCA === 'No' && remediation.futureProductYes && (remediation.guideNo || remediation.guideYes) ? (
            <div className="ncss-col-sm-12 inline-flex-display u-bold qrf-padding-zero ie-inline-display">
              <div className="ncss-col-sm-5  u-bold trf-data-text">
              </div>
              <div className="ncss-col-sm-8 pad-top">
                <div>
                  <p className='title-text' style={{ color: 'red' }}>
                    You will not be able to complete this form. Failure notification will remain open until you have completed your root cause analysis.
                  </p>

                </div>
              </div>
            </div>
          ) : null}
          {remediation.PDCA === 'Yes' && remediation.futureProductYes && (remediation.guideNo || remediation.guideYes) ? (
            <Fragment>
              <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  Why is this particular chemical used in your manufacturing process?<span className='astericks ml-neg3'>&#42;</span>
                  <Field
                    component={TextInput}
                    name="failureDesc"
                    type="textarea"
                    className="ncss-col-sm-12 u-bold trf-data-text"
                    maxLength={maxTextLength}
                  />
                </div>
              </div>
              <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  Describe your Root Cause findings<span className='astericks ml-neg3'>&#42;</span>
                  <Field
                    component={TextInput}
                    name="rootCause"
                    type="textarea"
                    className="ncss-col-sm-12 u-bold trf-data-text"
                    maxLength={maxTextLength}
                  />
                </div></div> <div className="ncss-col-sm-12 ncss-input-container qrf-padding-zero">
                <div className="ncss-col-sm-12 u-bold trf-data-text">
                  What are your proposed corrective actions?<span className='astericks ml-neg3'>&#42;</span>
                  <Field
                    component={TextInput}
                    name="correctiveAction"
                    type="textarea"
                    className="ncss-col-sm-12 u-bold trf-data-text"
                    maxLength={maxTextLength}
                  />
                </div>
              </div>
              <div className="ncss-col-sm-12 inline-flex-display p5-sm u-bold qrf-padding-zero ie-inline-display">
                <H5 className="ncss-col-sm-5  u-bold trf-data-text">
                  Have you completed the proposed corrective actions? <span className='astericks ml-neg3'>&#42;</span>
                </H5>
                <div className="ncss-col-sm-8 ncss-radio-container">
                  {currectiveActionFields.map(data => (
                    <div key={data.id} className="ncss-col-sm-2 description ncss-radio-container">
                      <Field
                        type="radio"
                        component={renderRadiobutton}
                        name="proposedCorrectiveAction"
                        value={data.value}
                        label={data.label}
                        id={data.id}
                        isIcon={false}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Fragment>
          ) : null}
          {remediation.proposedCorrectiveAction === 'Yes' && remediation.PDCA === 'Yes' && remediation.futureProductYes ? (
            <Fragment>
              <UploadAttachment uploadAction={attachmentQrf} attachment={attachment} />

            </Fragment>) : null}
          {remediation.proposedCorrectiveAction === 'No' && remediation.PDCA === 'Yes' && remediation.futureProductYes ? (
            <div className="ncss-col-sm-12 inline-flex-display p5-sm u-bold qrf-padding-zero ie-inline-display">
              <H5 className="ncss-col-sm-5  u-bold trf-data-text">
                Provide date for completion of corrective actions
              </H5>
              <div className="ncss-col-sm-8 ncss-radio-container">
                <div className="ncss-col-sm-4 ncss-radio-container">
                  <Field
                    component={DatePicker}
                    defaultValue={remediation.dateOfCompletion}
                    showTime={false}
                    name="dateOfCompletion"
                    dropUp={true}
                    minDate={new Date()}
                  />
                </div></div>
            </div>
          ) : null}

        </div>
        <div>
        </div>
      </div>
    </form>
  );
};
Remediation.propTypes = {
  successFill: PropTypes.bool,
  displaySubmitButtonQrf: PropTypes.func,
  displayClearButtonQrf: PropTypes.func,
  attachmentQrf: PropTypes.func
};
function mapStateToProps(state) {
  return {
    trfDetail: state.trf.trfData,
    remediation: getFormValues('Remediation')(state),
    qrfData: state.qrf.qrfData,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    submitQrf: (data, history) => {
      dispatch(createServiceAction('qrfSubmit', 'submitted')({ ...data, history }));
    },
    submitFrf: (data, history) => {
      dispatch(createServiceAction('frfSubmit', 'submitted')({ ...data, history }));
    },
    updateQrf: (data, history) => {
      dispatch(createServiceAction('qrfUpdate', 'submitted')({ ...data, history }));
    },
    clearFormValueQRF: () => {
      dispatch(clearFormValueQRF());
    },
  }
}

export default reduxForm({
  form: 'Remediation',
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(Remediation));